import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';
import NotificationService from '../../../core/services/NotificationService';
import FormService from '../../../core/services/FormService';

class CompanyListService {
  fetch = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      distributorId: null,
      companies: [],
      pagination: {
        current: 1,
        total: 0,
        pageSize: 50,
      },
    });
  }

  init = action((distributorId) => {
    this.companies = [];
    this.distributorId = distributorId;
    this.form.reset();
    this.load();
  });

  load = action((pagination, filters, sort) => {
    if (pagination) {
      this.pagination.current = pagination.current;
    }

    this.fetch
      .fetch({
        url: '/companies',
        query: {
          page: this.pagination.current,
          size: this.pagination.pageSize,
          ...(sort &&
            sort.field && {
              sort: {
                [sort.field]: sort.order === 'descend' ? 'desc' : 'asc',
              },
            }),
          query: {
            ...(this.form.getValue('name') && {
              name: {
                $regex: this.form.getValue('name'),
                $options: 'i',
              },
            }),
            ...(this.form.getValue('cnpj') && {
              cnpj: {
                $regex: this.form.getValue('cnpj'),
                $options: 'i',
              },
            }),
            ...(this.form.getValue('segment') && {
              segment: this.form.getValue('segment'),
            }),
            ...(this.form.getValue('distributor') && {
              distributor: this.form.getValue('distributor'),
            }),
            ...(this.distributorId && {
              distributor: this.distributorId,
            }),
          },
        },
      })
      .then(() => {
        if (this.fetch.data) {
          this.companies = this.fetch.data.docs;
          this.pagination.total = this.fetch.data.total;
        } else {
          this.companies = [];
        }
      });
  });

  handleRemove = action((company) => {
    ConfirmationDialogService.show(
      'Delete Company',
      `You are about to delete the company "${company.name}", Do you want to continue ?`,
      () => {
        this.fetch
          .fetch({
            url: `/companies/${company.id}`,
            method: 'delete',
          })
          .then(() => {
            if (this.fetch.data) {
              NotificationService.addNotification(`Company "${company.name}" deleted successfully.`, 'success');
              this.load();
            }
            if (this.fetch.error) {
              NotificationService.addNotification(this.fetch.error, 'error');
            }
          });
      }
    );
  });
}

const companyListService = new CompanyListService();

export default companyListService;
